angular.module('mx.SolutionBuilderAgent').component('mxDataControlSettingsPanel', {
	bindings: {
		preprocessors: '<',
		viewInfos: '<',
		showConfigureButton: '<',
		onConfigureClick: '&',
		onViewSelect: '&',
		autoRefreshConfig: '<',
		currentView: '<',
		availableRowHeights: '<',
		rowHeight: '=?',
		enableRowsColoring: '=?',
		viewParameters: '<',
	},
	controller: MxDataControlSettingsPanelCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-data-control-settings-panel/mx-data-control-settings-panel.html',
});

MxDataControlSettingsPanelCtrl.$inject = [
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.shell.EventService',
	'$scope',
];

function MxDataControlSettingsPanelCtrl(searchService, searchQueryService, personalizationService, eventService, $scope) {
	const vm = this;
	vm.noFilters = true;

	vm.$onInit = function () {
		personalizationService.getGridPersonalization(vm.viewParameters.id).then(function (personalization) {
			vm.hasPersonalization = typeof personalization === 'object' && Object.keys(personalization).length;
		});
	};

	vm.onColumnClick = function (column) {
		const context = searchService.currentContext();

		if (column && context.widgetId) {
			personalizationService.setColumnVisibility(context.widgetId, column.Name, column.visible);
		}
	};

	vm.clearColumnsPersonalization = function () {
		personalizationService.saveGridPersonalization({}, vm.viewParameters.id);
		eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SynchronizeWidget);
	};

	vm.getIconName = getIconName;

	eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.GridPersonalizationSaved,
		(e, data) => {
			if (data && data.contextKey === vm.viewParameters.id) {
				vm.hasPersonalization = typeof data.personalization === 'object' && Object.keys(data.personalization).length;
			}
		},
		$scope
	);

	return vm;

	function getIconName(type) {
		return (
			(type === mx.SolutionBuilderAgent.ContentWidgetViewType.Grid && 'grid_on') ||
			(type === mx.SolutionBuilderAgent.ContentWidgetViewType.List && 'view_list') ||
			(type === mx.SolutionBuilderAgent.ContentWidgetViewType.Tile && 'view_quilt') ||
			(type === mx.SolutionBuilderAgent.ContentWidgetViewType.Calendar && 'date_range') ||
			(type === mx.SolutionBuilderAgent.ContentWidgetViewType.Board && 'view_week')
		);
	}
}
